import { capitalize } from "lodash-es";
import moment from "moment/moment";
import { dateFormat } from "@/utils/constant";
// @ts-ignore
import Cookies from "js-cookie";

export const getLabelFromKey = (key_string: string) => {
  return key_string
    .split("_")
    .map((el) => capitalize(el))
    .join(" ");
};

export const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatDate = (date: string) => {
  return moment(date).format(dateFormat);
};

export function toOptions<T, K extends keyof T>(
  arr: T[],
  key_value: K,
  key_label: K
) {
  return arr.map((el) => ({
    value: `${el[key_value]}`,
    label: `${el[key_label]}`,
  }));
}

export function getCookie(key: string) {
  let da = undefined;
  const data = Cookies.get(key);
  if (data) {
    try {
      da = JSON.parse(data);
    } catch (error) {
      da = undefined;
    }
  }
  return da;
}

export function setCookie(
  key: string,
  v: string | Record<string, string | number>
) {
  Cookies.set(key, JSON.stringify(v));
  return true;
}
